import { DatePicker, Input } from 'antd'
import { useEffect, useState } from 'react'
// import { useSelector } from 'react-redux'
import { getProjectDateRange } from 'utils'
import moment from 'moment'
import './DateDropPicker.scss'

export const DateDropPicker = ({ value, onChange, item, types, flag, dateType, projectData }) => {
    const [date, setDate] = useState()
    const [backspace, setBackspace] = useState(false)
    const [inputValue, setInputValue] = useState('')
    // const userInfo = useSelector(state => state.HeaderSlice.userInfo)
    // const projectId = userInfo?.user?.projectId
    const type = 'Acquisition'

    const handleChange = date => {
        setDate(date)
    }

    useEffect(() => {
        if (!value) return
        setDate(dateType === 'd' ? moment(value, 'YYYY-MM-DD') : value)
    }, [])

    useEffect(() => {
        if (types === 'fcspTime' || types === 'lcspTime') {
            onChange(dateType === 'd' ? date?.format('YYYY-MM-DD') : date)
        }
        if (!date) return
        onChange(dateType === 'd' ? date?.format('YYYY-MM-DD') : date)
    }, [date])

    useEffect(() => {
        switch (types) {
            // case 'fspTime':
            //     if (item?.entity?.fspTime === item?.entity?.fcspTime) return
            //     if (!item?.entity?.fcspTime) return
            //     if (Number(item?.entity?.fsp) === Number(item?.entity?.fcsp)) {
            //         setDate(moment(item?.entity?.fcspTime, 'YYYY-MM-DD HH:mm'))
            //     }
            //     break
            case 'fcspTime':
                if (item?.entity?.fspTime === item?.entity?.fcspTime) return
                if (!item?.entity?.fspTime) return
                if (Number(item?.entity?.fsp) === Number(item?.entity?.fcsp)) {
                    setDate(moment(item?.entity?.fspTime, 'YYYY-MM-DD'))
                }
                break
            case 'fcspMinutes':
                if (item?.entity?.fspMinutes === item?.entity?.fcspMinutes) return
                if (!item?.entity?.fspMinutes) return
                if (Number(item?.entity?.fsp) === Number(item?.entity?.fcsp)) {
                    setInputValue(item?.entity?.fspMinutes)
                }
                break
            case 'lspTime':
                if (item?.entity?.lspTime === item?.entity?.lcspTime) return
                if (!item?.entity?.lcspTime) return
                if (Number(item?.entity?.lsp) === Number(item?.entity?.lcsp)) {
                    setDate(moment(item?.entity?.lcspTime, dateType === 'd' ? 'YYYY-MM-DD' : 'HH:mm'))
                }
                break
            case 'lspMinutes':
                if (item?.entity?.lspMinutes === item?.entity?.lcspMinutes) return
                if (!item?.entity?.lcspMinutes) return
                if (Number(item?.entity?.lsp) === Number(item?.entity?.lcsp)) {
                    setInputValue(item?.entity?.lcspMinutes)
                }
                break
            // case 'lcspTime':
            //     if (item?.entity?.lspTime === item?.entity?.lcspTime) return
            //     if (!item?.entity?.lspTime) return
            //     if (Number(item?.entity?.lsp) === Number(item?.entity?.lcsp)) {
            //         setDate(moment(item?.entity?.lspTime, 'YYYY-MM-DD HH:mm'))
            //     }
            //     break
            default:
                break
        }
    }, [item])

    const handleKeyDown = event => {
        let newDate
        switch (event.key) {
            case 'ArrowLeft': // 左箭头键
            case 'ArrowDown': // 下箭头键
                newDate = moment(date).subtract(1, 'day')
                break
            case 'ArrowRight': // 右箭头键
            case 'ArrowUp': // 上箭头键
                newDate = moment(date).add(1, 'day')
                break
            default:
                return // 如果不是方向键，则不做任何操作
        }
        setDate(newDate) // 更新日期状态
    }

    const handleChange1 = e => {
        let result = e.target.value.replace(/[^0-9]/g, '').slice(0, 5)
        let result2 = result
        let hour = result.slice(0, 2)
        let mite = result.slice(2, 4)
        if (result.length > 2) {
            if (hour >= 24) hour = 23
            if (mite >= 59) mite = 59
            if (hour === 24 && !backspace) mite = '00'
            result2 = hour + ':' + mite
            return setInputValue(result2)
        }
        return setInputValue(result)
    }

    const handleKeyDown1 = e => {
        if (e.key === 'Backspace') {
            setBackspace(true)
        } else {
            setBackspace(false)
        }
    }

    useEffect(() => {
        setInputValue(value)
    }, [])

    useEffect(() => {
        onChange(inputValue)
    }, [inputValue])

    return dateType === 'd' ? (
        <DatePicker
            format={'YYYY-MM-DD'}
            className='date'
            value={date}
            onChange={handleChange}
            allowClear={flag ? true : false}
            onKeyDown={handleKeyDown}
            disabledDate={currentDate => {
                if (!projectData) return
                const { startDate, endDate } = getProjectDateRange(projectData?.data?.data, type)
                const date = currentDate.format('YYYY-MM-DD')
                return date < startDate || date > endDate
            }}
        />
    ) : (
        <Input
            className='currentInput keepRight'
            placeholder=''
            value={inputValue}
            onChange={handleChange1}
            allowClear={false}
            onKeyDown={handleKeyDown1}
        />
    )
}
